import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueAutosuggest from 'vue-autosuggest'
import Tree from 'vuejs-tree'
Vue.use(Tree)

Vue.use(VueAxios, axios)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueAutosuggest)

const moment = require('moment')
require('moment/locale/da')
Vue.use(require('vue-moment'), {moment})

Vue.config.productionTip = false

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('labelize', function (value) {
  if (!value) return ''
  value = value.toString()
  value = value.replace(/___/g, ', ')
  value = value.replace(/_/g, ' ')
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('truncate', function(text, length, clamp) {
  clamp = clamp || '...'
/*   var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent; */
  return text.length > length ? text.slice(0, length) + clamp : text
})

Vue.filter('striphtml', function (value) {
  var div = document.createElement("div")
  div.innerHTML = value
  var text = div.textContent || div.innerText || ''
  return text
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
